// Place stickers (Phase 6 art, S5). Candidates are generated and keyed (art/gen/gen_run14.py,
// art/gen/key_stickers.py) and wait for the owner's pick; a picked one is a kit place's `sticker`.
// Until the owner switches them on, the app keeps today's look: a flag, default off (e2e and the
// owner can turn it on per tab with sessionStorage `tq-place-stickers` = 1).
import type { Pack, Place } from '../../shared/pack/schema'

export const PLACE_STICKERS_ON = false

function flagOn(): boolean {
  if (PLACE_STICKERS_ON) return true
  try {
    return sessionStorage.getItem('tq-place-stickers') === '1'
  } catch {
    return false
  }
}

/** The sticker image for a place (URL under the pack), or null while stickers are off or it has none. */
export function placeSticker(pack: Pick<Pack, 'meta'>, place: Pick<Place, 'sticker'>): string | null {
  return place.sticker && flagOn() ? `/packs/${pack.meta.id}/${place.sticker}` : null
}
